import { render, staticRenderFns } from "./ProductCategoryTree.vue?vue&type=template&id=b0ab38c4&scoped=true&lang=pug&"
import script from "./ProductCategoryTree.vue?vue&type=script&lang=js&"
export * from "./ProductCategoryTree.vue?vue&type=script&lang=js&"
import style0 from "./ProductCategoryTree.vue?vue&type=style&index=0&id=b0ab38c4&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0ab38c4",
  null
  
)

export default component.exports